import { render, staticRenderFns } from "./LostTags.vue?vue&type=template&id=7de37b25"
import script from "./LostTags.vue?vue&type=script&lang=ts"
export * from "./LostTags.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports